import { Header } from './Components/header';
import { PageFeedback } from './Components/pageFeedback';
import { Accordion } from './Components/accordion';
import { SidebarWithContent } from './Components/sidebarWithContent';
import { YouTube } from './Components/youtube';
import { FindAService } from './Components/findAService';

document.addEventListener('DOMContentLoaded', () => {
    Header.init();
    PageFeedback.init();
    Accordion.init();
    SidebarWithContent.init();
    YouTube.init();
    FindAService.init();
    enableEnterBehaviour();
})

function enableEnterBehaviour(): void {
    document.addEventListener('keydown', (event) => {
        if (event.key === "Enter") {
            const activeElement = document.activeElement as HTMLElement;
            activeElement.click();
        }
    })
}